import React from "react";
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';

const api = {
    uploadFile({ timeout = 550 }) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, timeout)
        })
    },
}

class PictureUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: '',
            files: [],
            uploaded: [],
            status: 'idle',
            mountFiles: false
        };
        this.handleImageChange = this.handleImageChange.bind(this);
        this.loadImages = this.loadImages.bind(this);
        this.exploreFiles = this.exploreFiles.bind(this);
    }

    //WARNING! To be deprecated in React v17. Use componentDidMount instead.
    componentWillMount() {
        const files = Object.values(this.props.files);

        if (files.length && !this.state.mountFiles) {
            this.setState({
                files: files,
                mountFiles: true
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { status, files } = this.state;

        if (prevProps.del !== this.props.del) {
            const fileObj = files.find(file => file.picURL === this.props.del);
            if (files.indexOf(fileObj) !== -1) {
                files.splice(files.indexOf(fileObj), 1);
                this.setState({
                    files: files
                });
            };

        }

        if (status === 'idle') return;

        if (status === 'loading') {
            console.log(`Total files: ${files.length}`);
            this.setState({ status: 'idle' })
            this.loadImages();
        }

        if (status === 'ready') {
            this.setState({ status: 'idle' })
            this.displayImages()
        }
    }
    handleImageChange(e) {
        this.setState({ inputValue: e.target.value })
        e.preventDefault();
        if (e.target.files.length) {
            const arrFiles = Array.from(e.target.files);
            console.log(e.target.files, arrFiles);

            const files = arrFiles.map((file, index) => {
                const picURL = window.URL.createObjectURL(file);
                console.log({ file, id: index + this.state.files.length, picURL });
                return { file, id: index + this.state.files.length, picURL };
            });

            this.setState({
                files: [...this.state.files, ...files],
                status: 'loading'
            });
        }
        this.setState({
            inputValue: ''
        })
    }

    loadImages() {
        const { files } = this.state;
        console.log(files);
        for (let i = 0; i < files.length; i++) {
            api.uploadFile(files[i])
                .then(() => {
                    const uploaded = this.state.uploaded;
                    uploaded.push(files[i]);
                    this.setState({
                        uploaded: uploaded,
                        status: i === (files.length - 1) ? 'ready' : this.state.status
                    })
                }).catch(err => console.error(err));
        }

    }

    displayImages() {
        this.props.onAssignPic(this.state.files, this.props.iter)
    }

    exploreFiles() {
        this.refs[`photoUploader${this.props.iter}`].click();
    }

    render() {
        // console.log(this.state);
        // console.log(this.props);

        return (
            <div style={{ display: 'inline' }}>
                <AddAPhotoIcon onClick={this.exploreFiles} style={{ marginTop: "5px", cursor: 'pointer' }} />
                <input type="file" accept="image/*" ref={`photoUploader${this.props.iter}`} onChange={this.handleImageChange} style={{ display: 'none' }} multiple />
            </div>
        );
    }
}

export default PictureUpload;



// WEBPACK FOOTER //
// ./src/components/CustomUpload/ItemPicUpload.jsx